import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";

import {
  rateSubtaskResourcePath,
  rateSubtaskResourceType,
} from "../resources/subtask/subtaskResourceConsts";

export type RateSubtaskMutationPayload = {
  rating: number;
  companyId: string;
  subtaskId: string;
};

export function rateSubtaskMutation(jsonApi: JsonApiClient) {
  return ({ rating, companyId, subtaskId }: RateSubtaskMutationPayload) =>
    jsonApi.createOne({
      path: rateSubtaskResourcePath(companyId, subtaskId),
      type: rateSubtaskResourceType,
      attributes: {
        rating,
      },
    });
}
